import { CostCenterClient } from "lib/ShiOneClient";
import { ApiClientConfig } from "../auth/ApiClientConfig";
const costCenterClient = new CostCenterClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export default costCenterClient;
